import I18n from 'I18n';
import { getIsUsingNodeJS } from 'automation-ui-action-features/actions/custom-code/utils/runtimePackageUtils';
export const DEFAULT_PYTHON_LANGUAGE = 'PYTHON39';
export const DEFAULT_NODE_LANGUAGE = 'NODE20X';
export const DEFAULT_LANGUAGE = DEFAULT_NODE_LANGUAGE;
export const getDefaultNodeFunctionSource = () => `exports.main = async (event, callback) => {
  /*****
    ${I18n.text('automation-ui-action-features.action-features.custom-code.sampleCode.inputsComment')}
  *****/
  const email = event.inputFields['email'];
  /*****
    ${I18n.text('automation-ui-action-features.action-features.custom-code.sampleCode.outputsCommentNode')}
  *****/
  callback({
    outputFields: {
      email: email
    }
  });
}`;
export const getDefaultPythonFunctionSource = () => `def main(event):
  # ${I18n.text('automation-ui-action-features.action-features.custom-code.sampleCode.inputsComment')}
  email = event["inputFields"]["email"]
  # ${I18n.text('automation-ui-action-features.action-features.custom-code.sampleCode.outputsCommentPython')}
  return {
    "outputFields": {
      "email": email
    }
  }`;
export const getDefaultFunctionSourceForRuntime = runtime => !getIsUsingNodeJS(runtime) ? getDefaultPythonFunctionSource() : getDefaultNodeFunctionSource();